export const LOADING = "LOADING";

export const CREATE_USER = "CREATE_USER";
export const USER_LOADING = "USER_LOADING";
export const DELETE_USER = "DELETE_USER";
export const GET_USERS = "GET_USERS";
export const UPDATE_USER = "UPDATE_USER";
